import { render, staticRenderFns } from "./ClazzPoster.vue?vue&type=template&id=a8caee84&"
import script from "./ClazzPoster.vue?vue&type=script&lang=js&"
export * from "./ClazzPoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports